import React, { useState } from "react";
import ClassificationTopbar from "./ClassificationTopbar";
import ClassificationImages, { ImageUrlModel, PayloadType } from "./ClassificationImages";
import { Box } from "@mui/material";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { fetchClassificationImagesfor } from "../../store/slice/ProjectImagesUploadedSlice";

interface AnnotationClassificationProps {
  id: string; // or number or whatever the type actually is
  taskType: string;
}

export interface AnnotationData {
  annotationId: string;
  type: string;
  annotation: string;
  projectLabelId: string;
  projectImageId: string;
  projectId: string;
  labelColor?: string;
}

const initialAnnotationData: AnnotationData = {
  annotationId: "",
  type: "",
  annotation: "",
  projectLabelId: "",
  projectImageId: "",
  projectId: "",
};

const AnnotationClassification = ({
  id,
  taskType,
}: AnnotationClassificationProps) => {


  const url = window.location.pathname;
  const segments = url.split("/");
  const lastParam = segments.pop() || "";
  const [gridCount, setGridCount] = useState(4);
  const [imagesSelection, setImagesSelection] = useState<string>("all");
  const [annotationImgs, setAnnotationImgs] = useState<ImageUrlModel[]>([]);
  const [startStop, setStartStop] = useState<boolean>(false);
  const [projectId, setProjectId] = useState<string>(lastParam);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showLabels, setShowLabels] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [annotatedImageCount, setAnnotatedImageCount] = useState<number>(0);
  const [selectedLbl, setSelectedLbl] = useState<AnnotationData>(
    initialAnnotationData
  );
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState<number>(4);
  const [totalPages, setTotalPages] = useState<number>(1);
  const dispatch = useDispatch<AppDispatch>();
  const [loader, setLoader] = useState<boolean>(false);



  const fetchImagesAccordingto = async () => {
    const actualPage = page === 1 ? 1 : page; // ensure it’s 1 even on reset

    let response;
    if (imagesSelection === "all") {
      response = await dispatch(
        fetchClassificationImagesfor({
          projectId,
          page: actualPage,
          count,
          annotation: "all",
        })
      );
    } else if (imagesSelection === "annotated") {
      response = await dispatch(
        fetchClassificationImagesfor({
          projectId,
          page: actualPage,
          count,
          annotation: "annotated",
        })
      );
    } else if (imagesSelection === "unannotated") {
      response = await dispatch(
        fetchClassificationImagesfor({
          projectId,
          page: actualPage,
          count,
          annotation: "unannotated",
        })
      );
    }

    if (response?.payload) {
      const payload = response.payload as PayloadType;
      console.log("Fetched images:", payload.imageUrlModel);
      setAnnotationImgs(payload.imageUrlModel);
      setCurrentPage(payload.currentPage);
      setTotalCount(payload.totalCount);
      setAnnotatedImageCount(payload.annotatedImageCount);
      setTotalPages(payload.totalPages);
      setShowLabels(false)
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  };

  return (
    <Box>
      <Box
        sx={{ display: "flex", flexDirection: "column", position: "relative" }}
      >
        <Box>
          <ClassificationTopbar
            gridCount={gridCount}
            setGridCount={setGridCount}
            imagesSelection={imagesSelection}
            setImagesSelection={setImagesSelection}
            startStop={startStop}
            setStartStop={setStartStop}
            selectedLbl={selectedLbl}
            setSelectedLbl={setSelectedLbl}
            taskType={taskType}
            page={page}
            setPage={setPage}
            count={count}
            setCount={setCount}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            setShowLabels={setShowLabels}
            showLabels={showLabels}
            projectId={projectId}
            setProjectId={setProjectId}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            loader={loader}
            setLoader={setLoader}
            fetchImagesAccordingto={fetchImagesAccordingto}
            annotationImgs={annotationImgs}
            setAnnotationImgs={setAnnotationImgs}
            setTotalCount={setTotalCount}
            totalCount={totalCount}
            setAnnotatedImageCount={setAnnotatedImageCount}
            annotatedImageCount={annotatedImageCount}
          />
        </Box>
        <Box sx={{ marginTop: "50px" }}>
          <ClassificationImages
            gridCount={gridCount}
            imagesSelection={imagesSelection}
            setImagesSelection={setImagesSelection}
            startStop={startStop}
            setStartStop={setStartStop}
            selectedLbl={selectedLbl}
            setSelectedLbl={setSelectedLbl}
            taskType={taskType}
            page={page}
            setPage={setPage}
            count={count}
            setCount={setCount}
            totalPages={totalPages}
            setTotalPages={setTotalPages}
            setShowLabels={setShowLabels}
            showLabels={showLabels}
            projectId={projectId}
            setProjectId={setProjectId}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            loader={loader}
            setLoader={setLoader}
            fetchImagesAccordingto={fetchImagesAccordingto}
            annotationImgs={annotationImgs}
            setAnnotationImgs={setAnnotationImgs}
            setTotalCount={setTotalCount}
            totalCount={totalCount}
            setAnnotatedImageCount={setAnnotatedImageCount}
            annotatedImageCount={annotatedImageCount}
          />
        </Box>
      </Box>
    </Box>
  );
};

// Wrap the export with withGUID to inject the guid prop
export default AnnotationClassification;
